import { Inject, Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { TabState } from '../interface/tabState.interface';

export type TabKey =
  | 'tab1'
  | 'tab2'
  | 'tab3'
  | 'tab4'
  | 'boxSit'
  | 'tabPicture'
  | 'boxFee'
  | 'tabVoucher'
  | 'offb'
  | 'iccoffb'
  | 'baoviet'
  | 'tasco'
  | 'pvi'
  | 'aaa'
  | 'mic'
  |'slider';

@Injectable({
  providedIn: 'root',
})
export class TabService {
  private tabs: Record<TabKey, TabState> = {
    tab1: { isOpen: false, isVisible: false },
    tab2: { isOpen: false, isVisible: false },
    tab3: { isOpen: false, isVisible: false },
    tab4: { isOpen: false, isVisible: false },
    boxSit: { isOpen: false, isVisible: false },
    tabPicture: { isOpen: false, isVisible: false },
    boxFee: { isOpen: false, isVisible: false },
    tabVoucher: { isOpen: false, isVisible: false },
    offb: { isOpen: false, isVisible: false },
    iccoffb: { isOpen: false, isVisible: false },
    baoviet: { isOpen: false, isVisible: false },
    tasco: { isOpen: false, isVisible: false },
    pvi: { isOpen: false, isVisible: false },
    aaa: { isOpen: false, isVisible: false },
    mic: { isOpen: false, isVisible: false },
    slider: { isOpen: false, isVisible: false }
  };
  private tabsReset: Record<TabKey, TabState> = { ...this.tabs };
  private tabStateSubject = new BehaviorSubject<Record<TabKey, TabState>>(
    this.tabsReset
  );

  constructor() {}

  reset(): void {
    // Reset về trạng thái ban đầu
    this.tabsReset = { ...this.tabs };
    // Emit trạng thái mới
    this.tabStateSubject.next(this.tabsReset);
  }

  getTabState(): Observable<Record<TabKey, TabState>> {
    return this.tabStateSubject.asObservable();
  }

  async toggleTab(tabKey: TabKey, event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }

    // Tạo bản sao của trạng thái tab hiện tại
    const newTabs = { ...this.tabs };

    // Kiểm tra xem có tab nào đang mở không
    const hasOpenTab = Object.values(newTabs).some((tab) => tab.isOpen);

    // Tạo mảng promises để đóng các tab khác
    const closePromises: Promise<void>[] = Object.entries(newTabs).map(
      ([key, tab]) => {
        if (key !== tabKey) {
          tab.isOpen = false;
          // Emit trạng thái mới ngay khi set isOpen = false
          this.tabStateSubject.next(newTabs);

          return new Promise<void>((resolve) => {
            setTimeout(() => {
              tab.isVisible = false;
              // Emit lại trạng thái sau khi set isVisible = false
              this.tabStateSubject.next(newTabs);
              resolve();
            }, 100);
          });
        }
        return Promise.resolve();
      }
    );

    // Đợi tất cả các tab khác đóng xong
    await Promise.all(closePromises);

    // Toggle tab được chọn
    const currentTab = newTabs[tabKey];
    if (currentTab.isOpen) {
      // Nếu tab đang mở thì đóng lại
      currentTab.isOpen = false;
      this.tabStateSubject.next(newTabs);

      await new Promise<void>((resolve) => {
        setTimeout(() => {
          currentTab.isVisible = false;
          this.tabStateSubject.next(newTabs);
          resolve();
        }, 100);
      });
    } else {
      // Chỉ đợi 100ms nếu có tab khác đang mở trước đó
      if (hasOpenTab) {
        await new Promise<void>((resolve) => setTimeout(resolve, 50));
      }

      // Nếu tab đang đóng thì mở ra
      currentTab.isVisible = true;
      this.tabStateSubject.next(newTabs);

      await new Promise<void>((resolve) => {
        setTimeout(() => {
          currentTab.isOpen = true;
          this.tabStateSubject.next(newTabs);
          resolve();
        }, 0);
      });
    }
  }
}
